export const pages_data = [
  {
    key: '1',
    page: 'Players',
    slug: 'students',
    status: true,
  },
  {
    key: '2',
    page: 'Coachs',
    slug: 'coachs',
    status: true,
  },
  {
    key: '3',
    page: 'Parents',
    slug: 'parents',
    status: true,
  },
  {
    key: '4',
    page: 'Guardians',
    slug: 'guardians',
    status: true,
  },
];
